import { useSelector } from "react-redux";
import { RootState } from "../../store";
import SmartdocLoading from "../indicators/SmartdocLoading";

interface AppDataLoadedFirstProps {
  children: React.ReactNode;
}

const AppDataLoadedFirst: React.FC<AppDataLoadedFirstProps> = ({
  children,
}) => {
  const user = useSelector((state: RootState) => state.user);

  if (user.userDataLoading) {
    return <SmartdocLoading />;
  }

  return <>{children}</>;
};

export default AppDataLoadedFirst;
